import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'uppercase'
})
export class UppercasePipe implements PipeTransform {

  language: string = 'en';

  constructor(private translateService: TranslateService) {
    this.language = translateService.currentLang;
  }

  transform(value: string, ...args: unknown[]): unknown {
    return value.toLocaleUpperCase(this.language);
  }

}
